module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"RemoveFromCart":{"notifications":{"success":"Položka byla odebrána z košíku"}}}}')
  delete Component.options._Ctor
}
